<div class="public-bg">
	<div class="public-content">
		<div class="public-app-logo">
			<img
				src="assets/images/logo.png"
				alt="App-Logo"
				class="is-logo-white" />
		</div>

		<div class="public-center-wrapper">
			<div class="public-wrapper">
				<h2 class="public-msg">
					{{ 'missingAcceptanceDocument.message' | translate }}
				</h2>

				<div class="public-wrapper-container">
					<div class="public-wrapper-content simple-card">
						<div class="public-wrapper-content-title is-bold">
							{{ 'missingAcceptanceDocument.contextInformation1' | translate }} {{ loggedUser?.Name }}
						</div>
						<div class="public-wrapper-content-description">
							{{ 'missingAcceptanceDocument.contextInformation2' | translate }}
						</div>

						<div class="public-form">
							<div class="checkboxes-wrapper">
								@for (missingAcceptanceDocument of missingAcceptanceDocuments; track missingAcceptanceDocument.DocumentId) {
									<eif-custom-checkbox
										[(ngModel)]="missingAcceptanceDocument.Accepted"
										(checkedChange)="allDocumentsAccepted()"
										[autoHeight]="true">
										<span>
											{{ 'missingAcceptanceDocument.readAndAcceptTermsMsg' | translate }}
											<a
												class="is-hyperlink"
												(click)="openLegalDocument(missingAcceptanceDocument)">
												{{ missingAcceptanceDocument.LegalDocumentType | translate: 'list-DocumentNamesLabel' }}
											</a>
											{{ getAdditionalDocumentText(missingAcceptanceDocument.LegalDocumentType) }}
										</span>
									</eif-custom-checkbox>
								}
							</div>
						</div>
					</div>

					<div class="public-footer">
						<a
							class="public-footer-link is-hyperlink"
							href="mailto:{{ 'help.email.support.email' | translate }}">
							{{ 'help.email.support' | translate }}
						</a>

						<div class="actions-wrapper">
							@if (missingAcceptanceDocuments.length > 0) {
								<eif-custom-button
									[text]="'button.refuse'"
									[color]="'danger'"
									(click)="refuseDocuments()">
								</eif-custom-button>
								<eif-custom-button
									[text]="'button.accept'"
									[color]="allDocsAccepted ? 'primary' : 'neutral'"
									[disabled]="!allDocsAccepted"
									(click)="!allDocsAccepted ? false : acceptDocuments()">
								</eif-custom-button>
							}

							@if (missingAcceptanceDocuments.length === 0) {
								<eif-custom-button
									[text]="'button.confirm'"
									[color]="'primary'"
									(click)="navigateToHome()">
								</eif-custom-button>
							}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<eif-copyright></eif-copyright>
</div>
